import Model from '@/models/Model.js';

export default class CourseCodeable extends Model {
    static entity = 'course_codeables';

    static fields() {
        return {
            id: this.attr(null),
            course_code_id: this.attr(null),
            course_codeable_id: this.attr(null),
            course_codeable_type: this.attr(null),
        };
    }
}
